'use client';

import { usePathname } from 'next/navigation';

import { FormattedMessage } from '@flipster/i18n';
import { TextButton } from '@flipster/react/design-system/text-button';
import { css } from '@flipster/styled-system/css';
import { hstack } from '@flipster/styled-system/patterns';

const noAccountPages = ['/login'];
const hasAccountPages = ['/signup', '/select-nationality'];

const authConditionalInfoOptions = {
  noAccount: {
    title: <FormattedMessage id='Common.r251107.Don_t_have_an_account_question' />,
    buttonText: <FormattedMessage id='Common.r250401.Sign_up' />,
    href: '/signup',
  },
  hasAccount: {
    title: <FormattedMessage id='Autogen_common.r251126.s_Already_signed_up_question' />,
    buttonText: <FormattedMessage id='Common.r250401.Log_in' />,
    href: '/login',
  },
};

const getConditionalInfo = (pathname: string) => {
  if (noAccountPages.some((p) => pathname.includes(p))) return authConditionalInfoOptions.noAccount;
  if (hasAccountPages.some((p) => pathname.includes(p))) return authConditionalInfoOptions.hasAccount;
  return null;
};
const SessionNudgeButton = () => {
  const pathname = usePathname();

  const conditionalInfo = getConditionalInfo(pathname);

  if (!conditionalInfo) return null;

  return (
    <div className={hstack({ bgColor: 'background.accent.promotion.tint', rounded: 8, p: 16, w: '100%' })}>
      <p className={css({ textStyle: 'Title/S', color: 'inverse.white' })}>{conditionalInfo.title} </p>

      <TextButton
        size='large'
        as='a'
        href={conditionalInfo.href}
        label={conditionalInfo.buttonText}
        css={{ ml: 'auto' }}
      />
    </div>
  );
};

export default SessionNudgeButton;
